import { mixpanelTrack } from "./mixpanelTrack";

const SECTION = "Profile";

export const trackAutomaticUpdates = (isOn: boolean) =>
  mixpanelTrack(isOn ? "automatic_updates_on" : "automatic_updates_off", {
    section: SECTION,
    action_type: isOn ? "user_investment" : "anti_action",
  });

export const trackNavigateOnboardingSteps = () =>
  mixpanelTrack("navigate_onboarding_steps", {
    section: SECTION,
    action_type: "user_investment",
  });

export const trackProfileUpgrade = () =>
  mixpanelTrack("upgrade", {
    section: SECTION,
    context: "cta",
    action_type: "lifecycle",
  });

export const trackManagePlan = () =>
  mixpanelTrack("manage_plan", {
    section: SECTION,
    action_type: "lifecycle",
  });

export const trackCancelSubscription = () =>
  mixpanelTrack("cancel_subscription", {
    section: SECTION,
    action_type: "anti_action",
  });
